import { render, staticRenderFns } from "./creaOrdineModal.vue?vue&type=template&id=83f3b530&scoped=true&"
import script from "./creaOrdineModal.vue?vue&type=script&lang=ts&"
export * from "./creaOrdineModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f3b530",
  null
  
)

export default component.exports